/** Scroll once the model actually contains the requested line, and not again on later edits. */
export function shouldScrollToRevealLine(
  lineCount: number,
  revealLine: number | null | undefined,
  revealedLine: number | null,
): boolean {
  if (revealLine == null || revealLine < 1) return false;
  if (lineCount < revealLine) return false;
  return revealedLine !== revealLine;
}
